import React from 'react'

// hixme-ui
import Container from '@hixme-ui/container'
import Text from '@hixme-ui/text'

import { currencyFormatter } from '../../../../../../../../Expenses/utils/expenses'

export type TotalMonthlyPremiumProps = {
  amount: number
  peopleCount?: number
}

const getPeopleLabel = ({ peopleCount }: { peopleCount: number }) => {
  if (peopleCount <= 0) return ''

  const personWord = peopleCount === 1 ? 'person' : 'people'
  return ` (for ${peopleCount} ${personWord})`
}

const TotalMonthlyPremium = ({ amount, peopleCount = 0 }: TotalMonthlyPremiumProps) => (
  <Container
    noPadding
    style={{
      boxSizing: 'border-box',
      margin: '6px 20px',
      backgroundColor: '#F1F5F9',
      borderRadius: '8px',
      padding: '10px 16px',
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '2px',
    }}
    data-testid="total-monthly-premium"
  >
    <Text
      div
      center
      style={{
        fontSize: '16px',
        fontWeight: 700,
        lineHeight: '20px',
        margin: 0,
      }}
    >
      {/* Clamp to 0 to match the per-paycheck line (PersonBenefitPrice
          renders `price > 0 ? price : 0`), so a negative bundle price can't
          show a negative monthly premium while per-paycheck shows $0.00. */}
      {currencyFormatter(amount > 0 ? amount : 0)}
    </Text>
    <Text
      div
      center
      thin
      light
      style={{
        fontSize: '12px',
        lineHeight: '16px',
        margin: 0,
      }}
    >
      Monthly Premium{getPeopleLabel({ peopleCount })}
    </Text>
  </Container>
)

export default TotalMonthlyPremium
